// shadcn/ui canonical cn() helper — merges Tailwind classes intelligently.
// Used by the marketing components to compose className props with
// conditional logic.

import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
